exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ninput[type='time'] {\n  cursor: text;\n}\n", ""]);

